const EMAIL_REGEX_STRING =
  '(^[^\\.\\s@][^\\s@]*(?!\\.)@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+$)'

export default function isEmailValid(email) {
  const EMAIL_REGEX = new RegExp(EMAIL_REGEX_STRING)
  return EMAIL_REGEX.test(email)
}
